import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'ramda';

import { handleErrorBase, handleSuccessBase } from '../../util/forms';
import { apiAdminReinstateCertification } from '../../api/certification';

import Modal from '../Modal';

const propTypes = {
  userCertification: PropTypes.object,
  updateCertifications: PropTypes.func,
};

class ReinstateCertificationModal extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show) {
      return { show: defaultTo(false, nextProps.show) };
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  render() {
    const { onHide, userCertification, show, updateCertifications } = this.props;

    return (
      <Modal show={show} onHide={onHide} title="Approve Reinstatement">
        <Modal.Body>
          <p>Are you sure you want to reinstate this user's certification?</p>
          <p>
            This will issue them a new Accredible certification and mark their current certification as "In Good
            Standing"
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={onHide}>
            Close
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={() =>
              apiAdminReinstateCertification(userCertification)
                .then((resp) => updateCertifications(resp.data))
                .then(() => handleSuccessBase('Success'))
                .then(onHide)
                .catch(() => handleErrorBase('There was a problem reinstating the certification'))
            }
          >
            Approve
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ReinstateCertificationModal.propTypes = propTypes;

export default ReinstateCertificationModal;
